import { createStore } from "redux";
import { combineReducers } from "redux";

export const initialState = {
  searchArticle: "",
  currentArticleDatas: {},
};

const customizationReducer = (state = initialState, action) => {
  switch (action.type) {
    case "searchArticle":
      return {
        ...state,
        searchArticle: action.payload,
      };
    case "currentArticleDatas":
      return {
        ...state,
        currentArticleDatas: action.payload,
      };
    default:
      return state;
  }
};

const reducer = combineReducers({
  customization: customizationReducer,
});

const store = createStore(reducer);
export default store;
